import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useDescope, useSession } from "@descope/react-sdk";
import { GlobalLoading } from "./GlobalLoading.js";
/**
 * Picks up a session started on another nxt host of the same environment (spec shared-sign-in-session).
 * The refresh token is a cookie on the shared auth host, but the SDK's startup refresh only asks for it
 * when this origin's localStorage holds its sign-in marker (`DSLI`), which an origin the user never
 * signed in on lacks. A plain `refresh()` is not subject to that check. Must render inside Descope's
 * AuthProvider.
 */
export function SharedSessionRestore({ children, fallback = _jsx(GlobalLoading, {}) }) {
    const { isAuthenticated, isSessionLoading } = useSession();
    const sdk = useDescope();
    const started = useRef(false);
    const [settled, setSettled] = useState(false);
    useEffect(() => {
        if (isSessionLoading || started.current)
            return;
        started.current = true;
        if (isAuthenticated) {
            setSettled(true);
            return;
        }
        const settle = () => setSettled(true);
        sdk.refresh().then(settle, settle);
    }, [isSessionLoading, isAuthenticated, sdk]);
    return _jsx(_Fragment, { children: settled ? children : fallback });
}
//# sourceMappingURL=SharedSessionRestore.js.map